import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetAudiencesForEntityList as GetAudiencesQuery,
    GetAudiencesForEntityListVariables as GetAudiencesQueryVariables,
    GetAudiencesForEntityList_audiences_edges_node as Audience,
} from 'nutshell-graphql-types';

import GET_AUDIENCES from '../queries/get-audiences.graphql';

export const useGetAudiences = (
    variables: GetAudiencesQueryVariables
): {
    isLoading: boolean;
    errorMessage: string | null | undefined;
    audiences: Audience[];
    refetch: () => Promise<any>;
} => {
    const {loading, refetch, data, error} = useQuery<GetAudiencesQuery, GetAudiencesQueryVariables>(
        GET_AUDIENCES,
        {
            variables,
            notifyOnNetworkStatusChange: true,
        }
    );

    const audiences = data ? data.audiences.edges.map((edge) => edge.node) : [];

    return {
        isLoading: loading,
        refetch,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
        audiences,
    };
};
